// extracted by mini-css-extract-plugin
export default {"actionItem":"mailConfirmationForm-module__actionItem__60srs"};